import { BreadCrumb } from "@kunduz/ui";
import React, { ReactElement } from "react";
import styles from "./planDetailBreadcrumb.module.scss";

export const PlanDetailV2Breadcrumb = (props: Props): ReactElement => {
  return (
    <section className={styles.base}>
      <BreadCrumb
        items={[
          {
            label: "Paketler",
            url: "/tr/paketler/sinifini-sec/",
          },
          {
            label: props.title,
          },
        ]}
        base={{ label: "Kunduz", url: "/" }}
      />
    </section>
  );
};

interface Props {
  title: string;
}
